import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { BaseUser } from '@abaco/web-common/src/BaseUser';
import { CompetenceObj } from "./models/Competence";
import { ContextFunctions } from './models/FunctionResponse';
import { UserProperties } from "./models/Properties";
import { ContractInfo } from "./models/User";
import { ContextResponse } from "./models/Context";

export default class SsoVuexModule extends AbacoVuexModule {
    @State() user!: BaseUser | null;
    @State() userFunctions!: ContextFunctions | null;
    @State() privacyChecks!: CompetenceObj | null;
    @State() basicContractValidity!: ContractInfo | undefined;
    @State() basicContractExpired!: boolean;
    @State() temporaryUserId!: string | null;
    @State() userContexts!: ContextResponse | null;
    @State() userProperties!: UserProperties | null;
    @State( { default: false } ) isLoginCompat!: boolean;
    @State({ default: null}) plotValidityDateFilter!: Date | null;
}
